/**
 * Incident Party Types (PROJ-007)
 * Manages affected parties (persons and companies) linked to incidents
 */

export interface IncidentParty {
  id: string;
  incidentId: string;
  personId: string | null;
  companyId: string | null;
  role: string;
  person?: {
    id: string;
    fullName: string;
    email: string;
    phone?: string | null;
  };
  company?: {
    id: string;
    legalName: string;
    tradeName?: string | null;
    taxId?: string | null;
  };
}

export interface ListIncidentPartiesParams {
  includeDetails?: boolean;
  role?: string;
}

export interface AddIncidentPartyPayload {
  personId?: string;
  companyId?: string;
  role: string;
}

export const PARTY_ROLES = {
  AFFECTED_PARTY: 'affected_party',
  DATA_SUBJECT: 'data_subject',
  WITNESS: 'witness',
  REPORTER: 'reporter',
  INVESTIGATOR: 'investigator',
  THIRD_PARTY: 'third_party',
  VENDOR: 'vendor',
  PARTNER: 'partner'
} as const;

export const PARTY_ROLE_LABELS: Record<string, string> = {
  affected_party: 'Parte Afectada',
  data_subject: 'Titular de Datos',
  witness: 'Testigo',
  reporter: 'Reportador',
  investigator: 'Investigador',
  third_party: 'Tercero',
  vendor: 'Proveedor',
  partner: 'Socio'
};
